<template>
  <div id="terms-conditions-modal" class="modal terms-conditions" @click.self="hide">
    <div class="modal-outer">
      <transition name="slide-fade">
        <div v-if="termsConditionsStore.show" class="modal-inner">
          <svg
            class="close"
            xmlns="http://www.w3.org/2000/svg"
            height="32"
            viewBox="0 0 24 24"
            width="32"
            @click.stop="hide"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>

          <!-- avoid padding issue on FF caused by overflow -->
          <div class="modal-inner-padding">
            <div class="modal-header">
              <h3>{{ settings.title }}</h3>
            </div>

            <div class="modal-content markdown-container">
              <div class="markdown" v-html="parsedDescription"></div>
            </div>

            <div class="modal-footer">
              <theme-button outline class="btn do-not-accept" @click="deny">
                {{ $t('base.do_not_accept') }}
              </theme-button>
              <theme-button class="btn accept" @click="accept">
                {{ $t('base.accept') }}
              </theme-button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { markdownToHtml } from 'Utilities/markdown'
import { User } from 'src/apis'
import ThemeButton from 'javascript/Common/ThemeButton'
import userSync from 'javascript/helpers/userSync'
import { useTermsConditionsStore } from 'Store/terms-conditions'
import { useSettingsStore } from 'Store/settings'
import { useCookieConsentStore } from 'Store/cookie-consent'

export default {
  components: {
    ThemeButton
  },

  setup() {
    const termsConditionsStore = useTermsConditionsStore()
    const settingsStore = useSettingsStore()
    const cookieConsentStore = useCookieConsentStore()

    return { termsConditionsStore, settingsStore, cookieConsentStore }
  },

  computed: {
    settings() {
      return this.termsConditionsStore.settings
    },

    parsedDescription() {
      return markdownToHtml(this.settings.body)
    }
  },

  methods: {
    close() {
      this.termsConditionsStore.setShow(false)
    },

    hide() {
      this.close()
      this.$gtag.recordEventUserPolicy('Hide')
    },

    deny() {
      this.close()
      this.$gtag.recordEventUserPolicy('Deny')
    },

    accept() {
      this.termsConditionsStore.setAccepted(true)
      userSync.setState({ toc_accepted: true })
      if (this.cookieConsentStore.isFunctionalCookieEnabled) {
        User.AcceptTermsConditions(this.settingsStore.getHotelId)
      }
      this.$gtag.recordEventUserPolicy('Accept')
      this.$emit('agree')
      this.close()
    }
  }
}
</script>
